import React, { useState } from 'react';
import { func, string, bool, elementType } from 'prop-types';
import { DropzoneCnt } from './styles';

/**
 * Renders dropzone to process files.
 * Performs accepted files type validation.
 * @returns {React.FC}
 */

const Dropzone = props => {
  const {
    handleDrop: handleDropF = () => null,
    placeholder = 'Drag and drop file here',
    unacceptedDataTypeMessage = 'Unaccepted data type',
    accept = '.',
    disabled = false,
    Container = DropzoneCnt
  } = props;
  const [dragging, setDragging] = useState(false);
  const [unacceptedDataType, setUnacceptedDataType] = useState(false);
  const acceptRegexArray = accept.split(',').map(a => new RegExp(a, 'i'));

  const handleDragOver = event => {
    event.preventDefault();
    event.stopPropagation();

    if (!disabled && event.dataTransfer?.items?.length > 0) {
      setDragging(true);
    }
  };
  const handleDragEnter = event => {
    event.preventDefault();
    event.stopPropagation();

    if (!disabled) {
      const itemsLength = event.dataTransfer.items.length;
      if (itemsLength > 0) {
        for (let i = 0; i < itemsLength; i += 1) {
          const itemType = event.dataTransfer.items[i].type;
          if (!acceptRegexArray.some(regex => regex.test(itemType) === true)) {
            setUnacceptedDataType(true);
          }
        }
      }
    }
  };
  const handleDragLeave = event => {
    event.preventDefault();
    event.stopPropagation();

    if (!disabled) {
      setDragging(false);
      if (unacceptedDataType) {
        setUnacceptedDataType(false);
      }
    }
  };
  const handleDrop = event => {
    event.preventDefault();
    event.stopPropagation();

    if (!disabled) {
      if (!unacceptedDataType) {
        handleDropF(event);
      }
      setDragging(false);
      setUnacceptedDataType(false);
    }
  };

  return (
    <Container
      isDragging={dragging}
      hasError={unacceptedDataType}
      isDisabled={disabled}
      onDragOver={handleDragOver}
      onDragEnter={handleDragEnter}
      onDragLeave={handleDragLeave}
      onDrop={handleDrop}
    >
      {unacceptedDataType ? unacceptedDataTypeMessage : placeholder}
    </Container>
  );
};

Dropzone.propTypes = {
  handleDrop: func,
  placeholder: string,
  unacceptedDataTypeMessage: string,
  accept: string, // Comma separated file extensions or valid MIME type
  disabled: bool,
  Container: elementType
};

export default Dropzone;
